var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconViewGridRack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8333 9.60001V5.81667C20.8333 4.64167 20.3 4.16667 18.975 4.16667H15.6083C14.2833 4.16667 13.75 4.64167 13.75 5.81667V9.59167C13.75 10.775 14.2833 11.2417 15.6083 11.2417H18.975C20.3 11.25 20.8333 10.775 20.8333 9.60001Z",
    stroke: "#7E8299",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8333 18.975V15.6083C20.8333 14.2833 20.3 13.75 18.975 13.75H15.6083C14.2833 13.75 13.75 14.2833 13.75 15.6083V18.975C13.75 20.3 14.2833 20.8333 15.6083 20.8333H18.975C20.3 20.8333 20.8333 20.3 20.8333 18.975Z",
    stroke: "#7E8299",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2503 9.60001V5.81667C11.2503 4.64167 10.717 4.16667 9.39199 4.16667H6.02533C4.70033 4.16667 4.16699 4.64167 4.16699 5.81667V9.59167C4.16699 10.775 4.70033 11.2417 6.02533 11.2417H9.39199C10.717 11.25 11.2503 10.775 11.2503 9.60001Z",
    stroke: "#7E8299",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2503 18.975V15.6083C11.2503 14.2833 10.717 13.75 9.39199 13.75H6.02533C4.70033 13.75 4.16699 14.2833 4.16699 15.6083V18.975C4.16699 20.3 4.70033 20.8333 6.02533 20.8333H9.39199C10.717 20.8333 11.2503 20.3 11.2503 18.975Z",
    stroke: "#7E8299",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconViewGridRack);
export default __webpack_public_path__ + "static/media/icon-view-grid-rack.e8919d78684cfe9de6543d080a563081.svg";
export { ForwardRef as ReactComponent };